import React from "react";
import { Form, Button } from "react-bootstrap";
// import Select from "react-select";
import { SocialMediaOption } from "../types";

interface FormInputsProps {
  topic: string;
  targetedKeyword: string;
  language: SocialMediaOption | null;
  creativity: SocialMediaOption | null;
  loadingTitles: boolean;
  loadingPost: boolean;
  errorMessage: string | null;
  hasBlogPost: boolean;
  onTopicChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeywordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLanguageChange: (option: SocialMediaOption | null) => void;
  onCreativityChange: (option: SocialMediaOption | null) => void;
  onGenerateTitles: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onExport: () => void;
}

export const FormInputs: React.FC<FormInputsProps> = ({
  topic,
  targetedKeyword,
  language,
  creativity,
  loadingTitles,
  loadingPost,
  errorMessage,
  hasBlogPost,
  onTopicChange,
  onKeywordChange,
  onLanguageChange,
  onCreativityChange,
  onGenerateTitles,
  onExport,
}) => {
  const languageOptions: SocialMediaOption[] = [
    { value: "english", label: "English" },
    { value: "spanish", label: "Spanish" },
    { value: "french", label: "French" },
    { value: "german", label: "German" },
  ];

  const creativityOptions: SocialMediaOption[] = [
    { value: "regular", label: "Regular" },
    { value: "high", label: "High" },
  ];

  return (
    <div className="p-4 border rounded" style={{ backgroundColor: "#f8f9fa" }}>
      {errorMessage && (
        <div className="alert alert-danger" role="alert">
          {errorMessage}
        </div>
      )}
      <div className="flex-grow-1 pe-3">
        <h5 className="fw-bold mb-2">Generate a blog post for this topic...</h5>
        <Form.Group controlId="topicInput">
          <Form.Control
            as="textarea"
            rows={8}
            value={topic}
            onChange={onTopicChange}
            placeholder="e.g. Tips for a productive morning routine"
            style={{
              borderColor: "#8CC540",
              borderWidth: "2px",
              paddingTop: "13px",
            }}
          />
        </Form.Group>
        <Form.Group controlId="targetedKeywordInput" className="mb-3">
          <Form.Label>Targeted Keyword (optional)</Form.Label>
          <Form.Control
            type="text"
            value={targetedKeyword}
            onChange={onKeywordChange}
            placeholder="e.g. morning productivity"
            style={{ borderColor: "#8CC540", borderWidth: "2px" }}
          />
        </Form.Group>
        <div className="d-flex align-items-end mt-3 gap-2">
          <Form.Group controlId="languageSelect">
            <Form.Label className="fw-bold">Language</Form.Label>
            <Form.Select
              value={language?.value || ""}
              style={{ width: "110px" }}
              onChange={(e) => {
                const val = languageOptions.find(
                  (x) => x.value === e.target.value
                );
                val && onLanguageChange(val);
              }}
            >
              {languageOptions.map((x, i) => (
                <option value={x.value} key={x.label}>
                  {x.label}
                </option>
              ))}
            </Form.Select>
            {/* <Select<SocialMediaOption>
              options={languageOptions}
              value={language}
              onChange={onLanguageChange}
              className="basic-single"
              classNamePrefix="select"
              styles={{
                container: (provided) => ({ ...provided, width: "150px" }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
              menuPlacement="auto"
            /> */}
          </Form.Group>
          <Form.Group controlId="creativitySelect">
            <Form.Label className="fw-bold">Creativity</Form.Label>
            <Form.Select
              value={creativity?.value || ""}
              style={{ width: "110px" }}
              onChange={(e) => {
                const val = creativityOptions.find(
                  (x) => x.value === e.target.value
                );
                val && onCreativityChange(val);
              }}
            >
              {creativityOptions.map((x, i) => (
                <option value={x.value} key={x.label}>
                  {x.label}
                </option>
              ))}
            </Form.Select>
            {/* <Select<SocialMediaOption>
              options={creativityOptions}
              value={creativity}
              onChange={onCreativityChange}
              className="basic-single"
              classNamePrefix="select"
              styles={{
                container: (provided) => ({ ...provided, width: "150px" }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
              menuPlacement="auto"
            /> */}
          </Form.Group>
          <Button
            variant="outline-secondary"
            onClick={onExport}
            style={{ height: "38px", padding: "0 15px" }}
            disabled={!hasBlogPost}
          >
            📤Export
          </Button>
          <div className="flex-grow-1 d-flex justify-content-end">
            <Button
              variant="warning"
              onClick={onGenerateTitles}
              disabled={loadingTitles || loadingPost}
              style={{
                backgroundColor: "#8CC540",
                borderColor: "#8CC540",
                color: "white",
                height: "38px",
              }}
            >
              {loadingTitles ? "Creating Titles..." : "Generate Titles"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
